import React, { useEffect, useState } from "react";
import { Settings, X } from "lucide-react";
import { useTranslation } from "react-i18next";

const themes = [
  { key: "default", class: "" },
  { key: "black", class: "theme-black" },
  { key: "green", class: "theme-green" },
  { key: "purple", class: "theme-purple" },
  { key: "orange", class: "theme-orange" }
];

const languages = [
  { code: "ta", label: "தமிழ்" },
  { code: "en", label: "English" },
  { code: "te", label: "తెలుగు" },
  { code: "ar", label: "العربية" }
];

const ThemeSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState(localStorage.getItem("theme") || "");
  const [isRTL, setIsRTL] = useState(localStorage.getItem("rtl") === "true");
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.body.className = selectedTheme;
    localStorage.setItem("theme", selectedTheme);
  }, [selectedTheme]);

  useEffect(() => {
    document.dir = isRTL ? "rtl" : "ltr";
    localStorage.setItem("rtl", isRTL);
    window.dispatchEvent(new Event("storage"));
  }, [isRTL]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className={`fixed bottom-2 z-50 ${isRTL ? "left-4" : "right-4"}`}>
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="bg-primary text-white p-2 rounded-full shadow-lg hover:bg-primary/80 transition"
          title={t("layout_settings")}
        >
          <Settings />
        </button>
      )}

      {isOpen && (
        <div className="relative mt-2 w-60 bg-white border shadow-lg rounded-md p-4 space-y-4 text-sm">
          <button
            onClick={() => setIsOpen(false)}
            className="absolute -top-9 right-0 bg-primary text-[var(--primary-text)] text-xs px-2 py-1 rounded hover:bg-primary/80 transition"
            title={t("close_settings")}
          >
            <X />
          </button>

          {/* Theme Dropdown */}
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              {t("select_theme")}
            </label>
            <select
              className="w-full border px-2 py-1 rounded"
              value={selectedTheme}
              onChange={(e) => setSelectedTheme(e.target.value)}
            >
              {themes.map((theme) => (
                <option key={theme.key} value={theme.class}>
                  {t(`themes.${theme.key}`)}
                </option>
              ))}
            </select>
          </div>

          {/* RTL/LTR Switch */}
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              {t("layout_direction")}
            </label>
            <button
              onClick={() => setIsRTL(!isRTL)}
              className="w-full px-2 py-1 border rounded text-gray-700 hover:bg-gray-100 hover:text-primary"
            >
              {isRTL ? t("switch_to_ltr") : t("switch_to_rtl")}
            </button>
          </div>

          {/* Language Dropdown */}
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Language
            </label>
            <select
              className="w-full border px-2 py-1 rounded"
              value={i18n.language}
              onChange={(e) => changeLanguage(e.target.value)}
            >
              {languages.map((lang) => (
                <option key={lang.code} value={lang.code}>
                  {lang.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
};

export default ThemeSwitcher;
